import { request } from '@/utils/request'

export const reqIntersectionList = () => request.get(`team-location/list`)

export const reqAddIntersection = (payload) =>
  request.post(`team-location/create`, payload)

export const reqUpdateIntersection = (payload) =>
  request.put(`team-location/update/?id=${payload.id}`, payload)

export const reqDeleteIntersection = (id) =>
  request.delete(`team-location/remove/?id=${id}`)



// WEBPACK FOOTER //
// ./src/api/teamBuildLocation/index.js